import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import logoBlue from "../../images/logo-blue.png";

type CertificationCoverageProps = {
  title?: string;
  description?: string;
  coverageItem?: string;
  coverageItemHref?: string;
  logoSrc?: string;
  logoAlt?: string;
};

const CertificationCoverage = ({
  title = "Certification Coverage",
  description = "This documentation supports implementation for:",
  coverageItem = "ONC Health IT Certification (170.315(g)(10))",
  coverageItemHref = "https://www.aaneel.com/2022/06/16/aaneel-onc-ehr-certification/",
  logoSrc = logoBlue,
  logoAlt = "AaNeel Connect",
}: CertificationCoverageProps) => {
  return (
    <section className="relative overflow-hidden rounded-2xl border border-[#e3e7f3] bg-white shadow-[0_4px_12px_rgba(4,30,121,0.04)] sm:rounded-[28px]">
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_240px]">
        <div className="relative flex min-w-0 flex-col justify-between gap-2 p-5 sm:p-6 md:p-7 lg:pr-8">
          <div>
            <h2 className="m-0 mb-3 text-xl font-semibold leading-tight sm:text-2xl">
              {title}
            </h2>
            <p className="m-0 text-sm leading-normal tracking-[0.0175rem] sm:text-[15px]">
              {description}
            </p>
          </div>

          <div className="flex flex-col gap-3 rounded-xl border border-[#e3e7f3] bg-[#f7faff] px-3.5 py-3.5 sm:flex-row sm:items-center sm:justify-between sm:gap-4 sm:px-4">
            <div className="flex min-w-0 items-start gap-3 sm:items-center">
              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white text-(--desaturateddarkblue) ring-1 ring-[#e3e7f3]">
                <VerifiedOutlinedIcon className="text-lg" />
              </div>
              <div className="min-w-0">
                <p className="m-0 text-[10px] font-semibold uppercase tracking-widest text-(--desaturatedbluecustom) sm:text-xs">
                  Supported Certification
                </p>
                <a
                  href={coverageItemHref}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-0.5 block text-sm font-semibold break-words underline! decoration-(--darkblue) underline-offset-2 transition-colors hover:opacity-80"
                >
                  {coverageItem}
                </a>
              </div>
            </div>

            <a
              href={coverageItemHref}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Open certification details"
              className="inline-flex w-max self-start items-center gap-1.5 rounded-full border border-[#d8deeb] bg-white px-3.5 py-1.5 text-xs font-semibold tracking-wide text-(--darkblue) transition-colors hover:opacity-80 sm:self-auto sm:shrink-0"
            >
              Learn more
              <OpenInNewOutlinedIcon className="text-sm!" />
            </a>
          </div>
        </div>

        <aside className="relative flex flex-col items-center justify-center px-6 py-8 text-center sm:py-10 lg:px-7 lg:py-8">
          <img
            src={logoSrc}
            alt={logoAlt}
            className="h-auto w-[120px] max-w-full object-contain sm:w-[140px]"
          />
        </aside>
      </div>
    </section>
  );
};

export default CertificationCoverage;
